import { useMemo } from 'react';

import { useCageController_AllCages } from '@/services/hooks';

import { mapCageListItemToDomain } from './mappers';
import type { UseGetAllCagesResult } from './types';

export function useGetAllCages(): UseGetAllCagesResult {
    const cagesQuery = useCageController_AllCages();

    const cages = useMemo(() => {
        return (cagesQuery.data?.data ?? []).map(mapCageListItemToDomain);
    }, [cagesQuery.data?.data]);

    return {
        ...cagesQuery,
        isLoading: cagesQuery.isPending,
        data: cages,
    };
}
